<template>
    <div class="dy-height">
        <!-- Message for leads -->
        <div class="custom-box">
            <h4>Message for leads</h4>

            <div class="form-group">
                <label>Headline <span class="required">*</span></label>
                <input type="text" v-model="leadMessage.headline" placeholder="Enter valid Headline " />
            </div>

            <div class="form-group">
                <label>Description <span class="required">*</span></label>
                <textarea v-model="leadMessage.description"
                    placeholder="Enter a marketing or legal disclaimer"></textarea>
            </div>
        </div>

        <!-- Additional action -->
        <div class="custom-box">
            <div class="box-header">
                <h4>Additional action <span class="required">*</span></h4>

                <v-icon icon="mdi-chevron-down" style="cursor: pointer" @click="showAdditional = !showAdditional" />
            </div>

            <div v-if="showAdditional">
                <div class="form-group">
                    <div class="radio-group">
                        <label>
                            <input type="radio" value="VIEW_WEBSITE" v-model="selectedAction" />
                            Go to Website
                        </label>
                        <label>
                            <input type="radio" value="CALL_BUSINESS" v-model="selectedAction" />
                            Call Business
                        </label>
                        <label>
                            <input type="radio" value="WHATSAPP" v-model="selectedAction" />
                            Chat on Whatsapp
                        </label>
                    </div>
                </div>

                <div class="form-group">
                    <label>Link <span class="required">*</span></label>
                    <input type="text" v-model="actionData.link" placeholder="https://example.com" />
                </div>

                <div class="form-group">
                    <label>Call to action <span class="required">*</span></label>
                    <v-select v-model="actionData.cta" :items="callToActionOptions" variant="outlined"
                        placeholder="select action" density="compact" hide-details style="width: 100%" />
                </div>

            </div>
        </div>
        <v-dialog v-model="dialog.show" width="400">
            <v-card>
                <v-card-title class="text-h6 font-weight-bold">
                    {{ dialog.success ? '' : '' }}
                </v-card-title>
                <v-card-text>
                    {{ dialog.message }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" @click="dialog.show = false">close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <div v-if="errors.length" class="error-list mb-4 mt-4">
            <p v-for="(err, index) in errors" :key="index" class="text-error">⚠ {{ err }}</p>
        </div>
    </div>
</template>

<script>
import { useSuperLeedForm } from '@/store/SuperLeedForm';

export default {
    name: 'EndingStep',
    props: { platform: String },
    computed: {
        store() {
            return useSuperLeedForm();
        },
        leadMessage: {
            get() {
                return this.store.MetaLeedEnding.leadMessage;
            },
            set(value) {
                this.store.MetaLeedEnding.leadMessage = value;
            },
        },
        selectedAction: {
            get() {
                return this.store.MetaLeedEnding.selectedAction;
            },
            set(value) {
                this.store.MetaLeedEnding.selectedAction = value;
            },
        },
        actionData: {
            get() {
                return this.store.MetaLeedEnding.actionData;
            },
            set(value) {
                this.store.MetaLeedEnding.actionData = value;
            },
        },
    },
    data() {
        return {
            errors: [],
            callToActionOptions: [
                'Apply now',
                'Learn more',
                'Sign up',
                'Download',
                'Contact us',
            ],
            showAdditional: true,
            dialog: {
                show: false,
                message: '',
                success: false,
            },
        };
    },
    methods: {
        validate() {
            this.errors = [];

            if (!this.leadMessage.headline || this.leadMessage.headline.trim() === "") {
                this.errors.push("Headline is required.");
            }

            if (!this.leadMessage.description || this.leadMessage.description.trim() === "") {
                this.errors.push("Description is required.");
            }

            if (!this.selectedAction) {
                this.errors.push("You must select an action.");
            }

            if (!this.actionData.link || this.actionData.link.trim() === "") {
                this.errors.push("Link is required.");
            } else {
                const linkRegex = /^(https?:\/\/)?([\w.-]+)\.([a-z]{2,})(\/\S*)?$/i;
                if (!linkRegex.test(this.actionData.link)) {
                    this.errors.push("Link must be a valid URL.");
                }
            }

            if (!this.actionData.cta || this.actionData.cta.trim() === "") {
                this.errors.push("Call to action is required.");
            }

            return this.errors.length === 0;
        },

        async submitForm() {
            try {
                await this.store.sendmeta();
                this.dialog = {
                    show: true,
                    success: true,
                    message: ' is created ',
                };
            } catch (err) {
                this.dialog = {
                    show: true,
                    success: false,
                    message: err,
                };
            }
        }
    }
};
</script>


<style scoped>
.text-error {
    color: #e53935 !important;
    font-size: 15px;
    margin-top: 6px;
}
.custom-box {
    background-color: #fff;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
    margin-bottom: 24px;
}

h4 {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 20px;
}

.box-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
}

.toggle-btn {
    background: transparent;
    border: none;
    font-size: 20px;
    cursor: pointer;
    padding: 0;
    line-height: 1;
}

.form-group {
    margin-bottom: 16px;
    display: flex;
    flex-direction: column;
}

.form-group label {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 6px;
    color: #333;
}

input,
textarea,
select {
    padding: 10px 12px;
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius: 8px;
    outline: none;
    transition: border-color 0.3s;
}

input:focus,
textarea:focus,
select:focus {
    border-color: #237276;
}

textarea {
    resize: vertical;
    min-height: 90px;
}

.radio-group {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.radio-group label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 500;
}

.radio-group input[type="radio"] {
    accent-color: #237276;
    width: 16px;
    height: 16px;
}

.dy-height {
    max-height: 70vh;
}
</style>
